/**
 * Swatches en tarjetas de producto: actualiza imagen, enlaces y variante del quick-add.
 */
function variantUrl(productUrl, variantId) {
  const base = String(productUrl).split('?')[0]
  return `${base}?variant=${variantId}`
}

function getFirstSlideImage(mediaEl) {
  if (!mediaEl) return null
  const swiperEl = mediaEl.querySelector('.product-card-media-swiper')
  if (swiperEl) {
    const firstSlide = swiperEl.querySelector('.swiper-slide')
    return firstSlide?.querySelector('img') || null
  }
  return mediaEl.querySelector('.media a img') || null
}

function slideSwiperToFirst(mediaEl) {
  const container = mediaEl?.querySelector('.product-card-media-swiper')
  if (!container) return
  const swiper = container.swiper
  if (swiper && typeof swiper.slideTo === 'function') {
    swiper.slideTo(0, 0)
  }
}

export function initProductCardSwatchInteractions() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button.product-card__swatch-link[data-variant-id]')
    if (!btn) return
    e.preventDefault()
    e.stopPropagation()

    const root = btn.closest('.product-card-wrapper')
    if (!root) return

    const productUrl = root.dataset.productUrl
    if (!productUrl) return

    const variantId = btn.dataset.variantId
    const previewSrc = btn.dataset.previewSrc
    const available = btn.dataset.variantAvailable === 'true'

    const media = root.querySelector('product-card-media')
    const img = getFirstSlideImage(media)
    if (img && previewSrc) {
      img.src = previewSrc
      img.removeAttribute('srcset')
      img.removeAttribute('sizes')
    }
    slideSwiperToFirst(media)

    const href = variantUrl(productUrl, variantId)
    root.querySelectorAll('[data-card-product-link]').forEach((el) => {
      if (el.tagName === 'A') el.setAttribute('href', href)
    })

    const input = root.querySelector('input.product-variant-id[name="id"]')
    if (input) {
      input.value = variantId
      input.disabled = !available
    }

    const submitBtn = root.querySelector('.quick-add__submit')
    if (submitBtn) {
      submitBtn.disabled = !available
    }

    const swatchWrap = btn.closest('[data-product-card-swatches]')
    swatchWrap?.querySelectorAll('.product-card__swatch-link').forEach((el) => {
      if (el instanceof HTMLButtonElement) {
        const on = el === btn
        el.classList.toggle('is-active', on)
        el.setAttribute('aria-pressed', on ? 'true' : 'false')
      }
    })
  })
}
